import React from "react";
import Section from "./Section";
import { community } from "../data/CommunityDetails";
import SocialIconLinks from "./SocialIconLinks";

// Shared body — role, org/location, bullets, social icons — identical
// across every card shape below.
const EntryBody = ({ entry }) => (
  <div>
    {entry.period && (
      <p className="mb-2 font-mono text-xs text-faint">{entry.period}</p>
    )}
    <h3 className="text-lg font-semibold">{entry.role}</h3>
    <p className="mt-1 flex flex-wrap items-center gap-2">
      <span className="rounded-full border border-line px-2.5 py-0.5 text-xs font-medium text-fg">
        {entry.org}
      </span>
      {entry.location && (
        <span className="text-xs text-faint">{entry.location}</span>
      )}
    </p>
    <ul className="mt-3 space-y-1.5">
      {entry.highlights.map((point) => (
        <li key={point} className="flex gap-2 text-sm text-muted">
          <span
            className="mt-2 h-1 w-1 shrink-0 rounded-full bg-faint"
            aria-hidden="true"
          />
          {point}
        </li>
      ))}
    </ul>
    <SocialIconLinks socials={entry.socials} label={entry.org} />
  </div>
);

const Community = () => (
  <Section
    id="community"
    title="Community"
    subtitle="I organize and speak at developer events across Web3, including workshops, meetups, and hackathons. Always open to giving a talk or joining the organizing team for an upcoming Web3 or AI event, so feel free to reach out."
  >
    <ol className="space-y-4">
      {community.map((entry) => {
        const key = `${entry.org}-${entry.location}`;
        const alt = `${entry.org}${entry.location ? `, ${entry.location}` : ""}`;

        // No photo: original plain layout, period in its own column.
        if (!entry.image) {
          return (
            <li
              key={key}
              className="grid gap-1 rounded-2xl border border-line bg-surface p-5 sm:grid-cols-[10rem_1fr] sm:gap-6 sm:p-6"
            >
              <p className="font-mono text-xs text-faint sm:pt-1">
                {entry.period}
              </p>
              <EntryBody entry={entry} />
            </li>
          );
        }

        // Every entry currently has a landscape photo — one uniform
        // full-width banner on top, since a wide image fills a wide slot
        // without cropping. If a portrait photo is ever added back, give
        // it a side column instead (aspect-[3/4], object-top) rather than
        // forcing it into this banner shape.
        return (
          <li
            key={key}
            className="overflow-hidden rounded-2xl border border-line bg-surface"
          >
            <div className="aspect-[3/2] w-full overflow-hidden bg-bg/40">
              <img
                src={entry.image}
                alt={alt}
                className="h-full w-full object-cover"
              />
            </div>
            <div className="p-5 sm:p-6">
              <EntryBody entry={entry} />
            </div>
          </li>
        );
      })}
    </ol>
  </Section>
);

export default Community;
